
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsd8e88ca57dee6ebba384d18b4bc1b060en from './en.yaml'
            i18n.addResourceBundle('en', 'd8e88ca57dee6ebba384d18b4bc1b060', flattenObject(nsd8e88ca57dee6ebba384d18b4bc1b060en), true, true);
        
        export default 'd8e88ca57dee6ebba384d18b4bc1b060';
    